<template>
  <div class="lyformitem">
    <label :style="{ width: (lw ? lw : 5) + 'em' }">{{ label }}</label>
    <p :style="{ width: 'calc(100% - ' + (lw ? lw : 5) + 'em' }">
      <slot></slot>
    </p>
  </div>
</template>
<script>
export default {
  props: ["label", "lw"],
};
</script>
<style lang="">
.lyformitem {
  display: flex;
  margin-bottom: 8px;
}
.lyformitem label {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/lyFormItem.vue